import SharedProjectVariablesPage from "~/areas/projects/components/Variables/ProjectVariables/SharedProjectVariablesPage";
export function BranchProjectVariablesPage() {
    return <SharedProjectVariablesPage />;
}
